/* Kingdom R5, 2026-10-10: full-screen menu behaviour and the phone filter toggle. */
(() => {
  function bindMenu() {
    const menu = document.querySelector('.kw-mobile-nav');
    if (!menu || menu.dataset.r5Bound) return;
    menu.dataset.r5Bound = 'true';
    const sync = () => {
      const open = !menu.hidden;
      document.documentElement.classList.toggle('kw-menu-open', open);
      if (open) {
        const first = menu.querySelector('a');
        if (first) first.focus({ preventScroll: true });
      }
    };
    new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
    sync();
  }

  function bindFilters() {
    const form = document.querySelector('.kw-catalog-controls');
    if (!form || form.dataset.r5Bound) return;
    form.dataset.r5Bound = 'true';
    const query = form.querySelector('.kw-catalog-query');
    if (!query) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'kw-filter-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Filter & sort';
    query.after(button);
    button.addEventListener('click', () => {
      const open = form.classList.toggle('kw-filters-open');
      button.setAttribute('aria-expanded', String(open));
    });
  }

  function init() { bindMenu(); bindFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0));
  else setTimeout(init, 0);
  document.addEventListener('shopify:section:load', init);
})();
